export default __webpack_public_path__ + "static/media/IMG_3846.984b503c.jpg";